import { render } from "./CreateFollowupAssessment.vue?vue&type=template&id=5314d662&scoped=true"
import script from "./CreateFollowupAssessment.vue?vue&type=script&lang=js"
export * from "./CreateFollowupAssessment.vue?vue&type=script&lang=js"

import "./CreateFollowupAssessment.vue?vue&type=style&index=0&id=5314d662&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5314d662"]])

export default __exports__